import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
export const companyBaseLatLng = createAsyncThunk('/basicSettings/companyBaseLatLng',  (LatLng) => {
 
  return {data : LatLng}
  })
  export const getData = createAsyncThunk('basicSettings/getData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BasicSettings/GetTableSummary', params, {mode:'cors'})
    return {
      params,
      data: response.data
    }
  })

  export const addBasicSettings = createAsyncThunk('basicSettings/addBasicSettings', async (Basic) => {
    
    const response = await axios.post('https://api.zasway.com:8443/BasicSettings/Create', Basic, {mode:'cors'})
    return response
  })

  export const editBasicSettings  = createAsyncThunk('basicSettings/editBasicSettings', async (Edit) => {
    const response = await axios.post('https://api.zasway.com:8443/BasicSettings/Update', Edit, {mode:'cors'})
    return response
  })

  export const getUsers = createAsyncThunk('basicSettings/getUsers', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/BasicSettings/GetUsers', params, {mode:'cors'})
    return {
      params,
      data: response.data
    }
  })

  export const getRefCompanyImage = createAsyncThunk('basicSettings/getRefCompanyImage', async (company) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetRefCompanyImage', company, {mode:'cors'})
    return response.data
  })

  export const UploadImage = createAsyncThunk('basicSettings/UploadImage', async (upload) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageRefCompany', upload, {mode:'cors'})
    return response
  })

  export const basicSettingsSlice = createSlice({
    name: 'basicSettings',
    initialState: {
      basicSettingsEditData: [],
      CompanyUserData: [],
      cmpBaseLatLng: null
    },
    reducers: {},
    extraReducers: builder => {
      builder
      .addCase(companyBaseLatLng.fulfilled, (state, action) => {
         
        state.cmpBaseLatLng = action.payload.data
     }) 
      .addCase(getData.fulfilled, (state, action) => {
        state.BasicEditData = action.payload.data
      })

      .addCase(editBasicSettings.fulfilled, (state, action) => {
        state.data = action.payload.data
      })

      .addCase(getUsers.fulfilled, (state, action) => {
        state.CompanyUserData = action.payload.data
      })
    }
  })
   
 export default basicSettingsSlice.reducer